import React, { PureComponent } from "react";
import Modal from "./modal/index";

type ModalProps = {
  title: string;
  primaryActionLabel?: string;
  secondaryActionLabel?: string;
  primaryAction?: () => void;
  secondaryAction?: () => void;
  primaryActionDisabled?: boolean;
  children: any;
  shouldCloseOnOverlayClick?: boolean;
  width: string;
};

export default class CustomModal extends PureComponent<ModalProps> {
  static defaultProps = {
    shouldCloseOnOverlayClick: false,
    width: "lg"
  };

  render() {
    const {
      title,
      primaryActionLabel,
      secondaryActionLabel,
      children,
      shouldCloseOnOverlayClick,
      primaryAction,
      primaryActionDisabled,
      secondaryAction,
      width
    } = this.props;
    let modalActions = [];
    if (primaryActionLabel && primaryAction) {
      const primaryButton = {
        text: primaryActionLabel,
        onClick: primaryAction,
        disabled: primaryActionDisabled
      };
      modalActions.push(primaryButton);
    }

    if (secondaryActionLabel && secondaryAction) {
      const secondaryButton = {
        text: secondaryActionLabel,
        onClick: secondaryAction
      };
      modalActions.push(secondaryButton);
    }

    return (
      <Modal
        heading={title}
        actions={modalActions}
        onClose={secondaryAction}
        shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
        width={width}
        appearance="primary"
      >
        {children}
      </Modal>
    );
  }
}
